<template>
    <v-card>
        <v-card-title style="position:fixed; z-index:9999; background:white; width:96.5%; border-bottom:1px solid rgba(0,0,0,0.2); font-size:28px; padding-bottom:25px;">
        <span>Editer Facture Magasinage N°{{factureContent.num_facture}}</span>
        </v-card-title>
        <v-row style="position:relative; width:100%; height:100%; top:100px;">
            <v-col cols="12" md="9" style="border-right:1px solid rgba(0,0,0,0.2); height:500px; overflow-y:scroll;">
                <v-form v-model="valid">
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                label="Référence Dossier"
                                outlined
                                v-model="factureContentTmp.dossier.num_dossier"
                                disabled
                                hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                label="Avis Relatif"
                                outlined
                                v-model="factureContentTmp.num_avis"
                                disabled
                                hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                label="Libellé"
                                v-model="factureContentTmp.data.libelle"
                                :rules="infoRules"
                                outlined
                                required
                                hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                label="Date"
                                outlined
                                required
                                :value="factureContentTmp.data.date | formatDate"
                                hide-details
                                disabled
                                ></v-text-field>
                            </v-col>
                            </v-row>    
                        </v-container>
                    </v-card-text>
                    <v-divider style="width:98%; margin: 0 auto;"></v-divider>
                    <v-card-title>
                        <span style="font-size:28px;">Informations Générales</span>
                        <v-spacer></v-spacer>
                        <template v-if="currentDossierVar === null">
                            <v-col cols="12" sm="6" md="2">
                                <v-dialog v-model="setDataDialog" persistent max-width="600px">
                                    <v-card>
                                        <v-card-title>
                                        <span class="headline">Ajouter Objet-Facture</span>
                                        </v-card-title>
                                        <v-card-text>
                                        <v-container>
                                            <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field label="Titre" v-model="dataTmp.name" required></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field label="Valeur" v-model="dataTmp.value" required></v-text-field>
                                            </v-col>
                                            </v-row>
                                        </v-container>
                                        <small>*indicates required field</small>
                                        </v-card-text>
                                        <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="setDataDialog = false">Annuler</v-btn>
                                        <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);" class="elevation-0" dark @click="setData">Ajouter</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    </v-dialog>
                            </v-col>
                        </template>
                    </v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <template v-if="currentDossierVar !== null">
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Type Dossier"
                                        outlined
                                        :disabled="currentDossierVar !== null"
                                        v-model="currentDossierVar.type"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Classe Dossier"
                                        outlined
                                        :disabled="currentDossierVar !== null"
                                        v-model="currentDossierVar.classe"
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <template v-if="currentDossierVar.classe !== 'Aérien'">
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Escale"
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.escale"
                                            outlined
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Voyage"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.voyage"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Consignataire"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.consig"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Armateur"
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.armateur"
                                            outlined
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Navire"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.navire"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Date d'embarquement"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.from_date"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Port d'embarquement"
                                            outlined
                                            required
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.port_from"
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Date de débarquement"
                                            outlined
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.to_date"
                                            required
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="3">
                                            <v-text-field
                                            label="Port de débarquement"
                                            outlined
                                            required
                                            :disabled="currentDossierVar !== null"
                                            v-model="currentDossierVar.port_to"
                                            hide-details
                                            ></v-text-field>
                                        </v-col>
                                        <template v-if="currentDossierVar.classe === 'Groupage'">
                                            <v-col cols="12" sm="6" md="3">
                                                <v-text-field
                                                label="Type Conteneur"
                                                outlined
                                                :disabled="currentDossierVar !== null"
                                                v-model="currentDossierVar.conteneur_type"
                                                required
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="3">
                                                <v-text-field
                                                label="N° Conteneur"
                                                outlined
                                                :disabled="currentDossierVar !== null"
                                                v-model="currentDossierVar.conteneur_num"
                                                required
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="3">
                                                <v-text-field
                                                label="N° Escale Magasin"
                                                outlined
                                                :disabled="currentDossierVar !== null"
                                                v-model="currentDossierVar.num_escale_magasin"
                                                required
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="3">
                                                <v-text-field
                                                label="Date Dépotage"
                                                outlined
                                                :disabled="currentDossierVar !== null"
                                                :value="currentDossierVar.date_depotage | formatDate"
                                                required
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                        </template>
                                    </template>
                                    <v-col cols="12" sm="6" md="3" v-if="currentDossierVar.classe === 'Groupage'">
                                        <v-text-field
                                        :rules="infoRules"
                                        label="Bureau"
                                        v-model="factureContentTmp.bureau"
                                        outlined
                                        disabled
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3" v-if="currentDossierVar.classe === 'Groupage'">
                                        <v-text-field
                                        :rules="infoRules"
                                        label="Valeur"
                                        v-model="factureContentTmp.valeur"
                                        outlined
                                        disabled
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3" v-if="currentDossierVar.classe === 'Groupage'">
                                        <v-text-field
                                        :rules="infoRules"
                                        label="Code Magasin"
                                        v-model="factureContentTmp.code_magasin"
                                        outlined
                                        disabled
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="P/C"
                                        :rules="infoRules"
                                        outlined
                                        v-model="factureContentTmp.pc"
                                        disabled
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-autocomplete
                                        label="Correspondant"
                                        outlined
                                        :rules="infoRules"
                                        v-model="factureContentTmp.correspondant"
                                        :items="correspondantList"
                                        disabled
                                        item-text="nom"
                                        item-value="id"
                                        :value="factureContentTmp.correspondant"
                                        required
                                        hide-details
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Terme"
                                        :rules="infoRules"
                                        outlined
                                        v-model="factureContentTmp.terme"
                                        disabled
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                        label="Fournisseur"
                                        :rules="infoRules"
                                        outlined
                                        v-model="factureContentTmp.fournisseur"
                                        disabled
                                        required
                                        hide-details
                                        ></v-text-field>
                                    </v-col>      
                                </template>
                                <v-col cols="12" sm="6" md="3">
                                    <v-autocomplete
                                    label="Agent Commercial"
                                    outlined
                                    :rules="infoRules"
                                    v-model="factureContentTmp.agent"
                                    :items="agentList"
                                    item-text="nom"
                                    disabled
                                    item-value="id"
                                    :value="factureContentTmp.agent"
                                    required
                                    hide-details
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-autocomplete
                                    label="Client"
                                    :rules="infoRules"
                                    outlined
                                    v-model="factureContentTmp.client_id"
                                    :items="listClient"
                                    disabled
                                    item-text="fullname"
                                    item-value="id"
                                    :value="factureContentTmp.client_id"
                                    required
                                    hide-details
                                    ></v-autocomplete>
                                </v-col>
                                <template v-if="currentDossierVar === null">
                                    <v-col v-for="(dataRow, key) in data" v-bind:key="key" cols="12" sm="6" md="3">
                                        <v-row style="padding:0; margin:0px;">
                                            <v-col class="pa-0 ma-0" cols="12" md="11"><v-text-field :label="dataRow.name" outlined hide-details v-model="data[key].value" :value="dataRow.value" ></v-text-field></v-col>
                                            <v-col class="pa-0 ma-0 pt-2" cols="12" md="1"><v-btn color="error" @click="deleteData(dataRow)" icon><v-icon>mdi-delete</v-icon></v-btn></v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-btn @click="setDataDialog = true" class="pa-6" :ripple="false" style="border: 2px solid; border-image-slice: 1; font-size: 12px; border-width: 2px; border-image-source: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);" large text>
                                            <span style="font-weight:700;background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%);-webkit-background-clip: text;-webkit-text-fill-color: transparent;">Nouvel Objet-Facture</span>
                                        </v-btn>
                                    </v-col>
                                </template>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field
                                    label="Date Dépotage"
                                    outlined
                                    :disabled="currentDossierVar !== null"
                                    :value="currentDossierVar.date_depotage | formatDate"
                                    required
                                    hide-details
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                        <v-menu
                                            ref="menu_enlevement"
                                            v-model="menu_enlevement"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="factureContentTmp.data.date_enlevement | formatDate"
                                                label="Date Enlèvement"
                                                readonly
                                                outlined
                                                hide-details
                                                :rules="magasinRules"
                                                required
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker @change="change_jrs" v-model="factureContentTmp.data.date_enlevement" @input="menu_enlevement = false" :min="currentDossierVar.date_depotage" no-title scrollable></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Nombre De Jours"
                                            outlined
                                            v-model="nb_jours"
                                            disabled
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-select
                                            label="Calcul Magasinage En Fonction de"
                                            :items='["Poids", "Volume"]'
                                            outlined
                                            v-model="calcul_en_fc"
                                            @change="typeCalculChange"
                                            required
                                            :rules="magasinRules"
                                            hide-details
                                        >    
                                        </v-select>
                                    </v-col>    
                                    
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Durée Période 1"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            type="Number"
                                            v-model="period1"
                                            @change="calculReste"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="PUHT Période 1"
                                            :rules="magasinRules"
                                            required
                                            outlined
                                            type="Number"
                                            v-model="prix_period1"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Franchise"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            type="Number"
                                            @change="calculReste"
                                            v-model="franchise"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Valeur"
                                            outlined
                                            required
                                            v-model="currentFactureTmp.type_calcul_value"
                                            disabled
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Durée Période 2"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            v-model="period2"
                                            @change="calculReste"
                                            hide-details
                                            type="Number"
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="PUHT Période 2"
                                            outlined
                                            :rules="magasinRules"
                                            required
                                            v-model="prix_period2"
                                            hide-details
                                            type="Number"
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"></v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="Durée Hors Période"
                                            outlined
                                            type="Number"
                                            required
                                            disabled
                                            v-model="hors_periode"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="3">
                                        <v-text-field
                                            label="PUHT Hors Période"
                                            outlined
                                            type="Number"
                                            :rules="magasinRules"
                                            v-model="prix_hors_periode"
                                            hide-details
                                        >    
                                        </v-text-field>
                                    </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider style="width:98%; margin: 0 auto;"></v-divider>
                    <v-card-title style="font-size:28px;"><span>Marchandises</span></v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col md="12">
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                        <thead>
                                            <tr>
                                            <th class="text-left">Rub.</th>
                                            <th class="text-left">Colis.</th>
                                            <th class="text-left">Description</th>
                                            <th class="text-left">Poids</th>
                                            <th class="text-left">Volume</th>
                                            <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(marchandise,index) in marchandises" v-bind:key="index">
                                                <td class="text-left">{{marchandise.rub}}</td>
                                                <td class="text-left">{{marchandise.colis}}</td>
                                                <td class="text-left">{{marchandise.description}}</td>
                                                <td class="text-left">{{marchandise.poids}} Kg</td>
                                                <td class="text-left">{{marchandise.volume}}</td>
                                                <td class="text-left">
                                                    <v-icon
                                                        small
                                                        @click="deleteMarchandises(marchandise)"
                                                    >
                                                        mdi-delete
                                                    </v-icon>
                                                </td>
                                            </tr>
                                        </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider style="width:98%; margin: 0 auto;"></v-divider>
                    <v-card-title style="font-size:28px;"><span>Préstations</span></v-card-title>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col md="2">
                                    <v-text-field v-model="searchPrest" append-icon="mdi-magnify" label="Rechercher une prestation.." hide-details></v-text-field>
                                    <v-treeview 
                                        style="text-align:left;"
                                        :items="items"
                                        activatable
                                        :search="searchPrest"
                                        item-key="id"
                                        open-on-click
                                    >
                                    <template slot="label" slot-scope="{ item }">
                                    <a v-if="item.name !== 'Préstations' && item.name !== 'Fret'" style="width: 100%;display: block;padding: 15px;" @click="selectPrest(item.prestation.code_prestation, prestations.length)">{{ item.name }}</a>
                                    <a v-else style="width: 100%;display: block;padding: 15px;">{{ item.name }}</a>
                                    </template>
                                    </v-treeview>
                                </v-col>
                                <v-col>
                                    <v-data-table
                                        hide-default-footer
                                        :headers="_headersPrestations"
                                        :items="prestations"
                                        item-key="key"
                                        :items-per-page=100
                                        >
                                        <template v-slot:[`item.description`]="props">
                                            <v-edit-dialog
                                            :return-value.sync="props.item.description"
                                            > {{ props.item.description }}
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.description"
                                                label="Edit"
                                                persistent
                                                counter
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>
                                        <template v-slot:[`item.montantTva`]="props">
                                            {{props.item.montantTva.toFixed(3)}}
                                        </template>
                                        <template v-slot:[`item.montant`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.montant"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.montant).toFixed(3)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier montant</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.montant"
                                                label="Edit"
                                                single-line
                                                counter
                                                type="number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>
                                        
                                        <template v-slot:[`item.cour`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.cour"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.cour).toFixed(3)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier Cours</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.cour"
                                                label="Edit"
                                                single-line
                                                counter
                                                type="number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.tva`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.tva"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.tva).toFixed(0)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier TVA</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.tva"
                                                label="Edit"
                                                single-line
                                                counter
                                                type="number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.devise`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.devise"
                                            large
                                            persistent
                                            >
                                            <div>{{props.item.devise}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier Devise</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-select label="Devise" v-model="props.item.devise" :items="['TND', 'USD', 'EUR']" autofocus required></v-select>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.montantDevise`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.montantDevise"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.montantDevise).toFixed(3)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier Montant Devise</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.montantDevise"
                                                label="Edit"
                                                single-line
                                                counter
                                                type="Number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.actions`]="{ item }">
                                            <v-icon
                                                small
                                                @click="deletePrestation(item)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-form>
            </v-col>
            <v-col cols="12" md="3" style="position:absolute; text-align:left; right:0; background:white;">
                <v-card-title style="font-size: 36px;"><span>Total Facture</span></v-card-title>
                <span class="total-line">Total Non Taxable : <b style="float:right;">{{totalnt.toFixed(3)}} TND</b></span><br/>
                <span class="total-line">Total Taxable : <b style="float:right;">{{totalt.toFixed(3)}} TND</b></span><br/>
                <span class="total-line">Total TVA : <b style="float:right;">{{totaltva.toFixed(3)}} TND</b></span><br/>
                <!-- <span class="total-line">Timbre Fiscal :<b style="float:right;"> 0.600 TND</b></span><br/> -->
                <div class="timbre-total">
                    <v-edit-dialog
                    :return-value.sync="factureContent.timbre"
                    > <span class="total-line">Timbre Fiscal :<b style="float:right;"> {{ Number(factureContent.timbre).toFixed(3) }} TND</b></span><br/>
                    <template v-slot:input>
                        <v-text-field
                        v-model="factureContent.timbre"
                        label="Edit"
                        persistent
                        counter
                        ></v-text-field>
                    </template>
                    </v-edit-dialog>
                </div>
                <span class="total-line">Total TTC : <b style="float:right;">{{total.toFixed(3)}} TND</b></span><br/>
            </v-col>
        </v-row>
        <v-card-title style="font-size: 36px; margin-top:115px;">
            <span>Réglement</span>
            <v-spacer></v-spacer>
            <v-switch
            v-model="reglement"
            ></v-switch>
        </v-card-title>
        <v-card-text v-if="reglement">
            <v-container fluid>
                <v-snackbar
                    v-model="snackbar"
                    :color="snackColor"
                    right
                    top
                    >
                    {{ snackText }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                        dark
                        text
                        v-bind="attrs"
                        @click="snackbar = false"
                        >
                        Fermer
                        </v-btn>
                    </template>
                </v-snackbar>
                <v-row>
                    <v-col md="2">
                        <v-text-field
                            label="Mode Réglement"
                            outlined
                            v-model="reglementTmp.mode"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="Banque"
                            v-model="reglementTmp.banque"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="N° Pièce"
                            v-model="reglementTmp.num_piece"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="3">
                        <v-text-field
                            label="Client"
                            v-model="reglementTmp.client"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="2">
                        <v-text-field
                            label="Montant"
                            v-model="reglementTmp.montant"
                            outlined
                            type="number"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col md="1">
                        <v-btn color="primary" @click="setReglement" fab><v-icon>mdi-arrow-down</v-icon></v-btn>
                    </v-col>
                    <v-col md="12">
                        <v-simple-table class="text-left" dense>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                <th class="text-left">Mode Réglement</th>
                                <th class="text-left">Banque</th>
                                <th class="text-left">N° Pièce</th>
                                <th class="text-left">Client</th>
                                <th class="text-left">Montant</th>
                                <th class="text-left">Actions</th>
                                </tr>
                            </thead>
                            <tbody v-if="reglements.length > 0">
                                <tr v-for="(item, key) in reglements" v-bind:key="key">
                                    <td>{{item.mode}}</td>
                                    <td>{{item.banque}}</td>
                                    <td>{{item.num_piece}}</td>
                                    <td>{{item.client}}</td>
                                    <td>{{item.montant}} TND</td>
                                    <td>
                                        <v-icon
                                            small
                                            @click="deleteReglement(item)"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeFacture">Fermer</v-btn>
        <v-btn  style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" dark @click="editFacture">Editer</v-btn>
        </v-card-actions>
        <v-dialog
            v-model="alertReglement"
            max-width="450"
            >
            <v-card>
                <v-card-text class="pt-5">
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-icon color="warning" style="font-size:42px;">mdi-alert</v-icon>
                        </v-col>
                        <v-col cols="12" md="10" class="text-left"><span style="font-size:18px;"> Etes vous sûre de vouloir passer cette facture sans reglements?</span></v-col>
                    </v-row>
                    
                </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="gray darken-1"
                    text
                    @click="checkReglement(false)"
                >
                    Annuler
                </v-btn>

                <v-btn
                    color="warning darken-1"
                    text
                    @click="checkReglement(true)"
                >
                    Accepter
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    name:'edit-magasinage-facture',
    props: ['factureContent', 'dossierId'],
    data: () => ({
        currentDossierId: 0,
        snackbar: false,
        snackText: '',
        snackColor: '',
        currentFactureTmp: {
            id: null,
            type_calcul: 'Poids',
            dossier: {},
            client: {},
            correspondant: {},
            agent: {},
            marchandises: []
        },
        data: [],
        reglementHeaders: [
            { text: 'Mode Réglement', value: 'mode' },
            { text: 'Banque', value: 'banque' },
            { text: 'N° Pièce', value: 'num_piece' },
            { text: 'Client', value: 'client' },
            { text: 'Montant', value: 'montant' },
            { text: 'Actions', value: 'actions' }
        ],
        marchandiseTmp: {
            cont_type: null,
            rub: '',
            cont_numero: null,
            colis: '',
            description: '',
            poids: '',
            volume: null
        },
        headersPrestations: [
            {
            text: 'Code',
            align: 'start',
            sortable: false,
            value: 'code_prestation',
            visible : true
            },
            { text: 'Desc. prestations', value: 'description', visible: true },
            { text: 'TVA %', value: 'tva', visible: true },
            { text: 'Montant TVA', value: 'montantTva', visible: true },
            { text: 'Mnt Devise', value: 'montantDevise', visible: true },
            { text: 'Devise', value: 'devise', visible: true },
            { text: 'Cours', value: 'cour' , visible: true},
            { text: 'Montant', value: 'montant', visible: true },
            { text: 'Actions', value: 'actions', visible: true },
        ],
        listAvis: [],

        listClient: [],
        reglements: [],
        reglementTmp: {
            montant: 0,
            mode: '',
            client: '',
            num_piece: '',
            banque: ''
        },
        titreFacture: '',
        prestations: [],
        reglement: true,
        totalnt: 0,
        totalt: 0,
        setDataDialog: false,
        totaltva: 0,
        total: 0,
        todayDate: ("0"+new Date().getDate()).slice(-2)+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+new Date().getFullYear(),
        todayDateSql: new Date().getFullYear()+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+("0"+new Date().getDate()).slice(-2),
        facture: {
            global: {}
        },
        alertReglement: false,
        confirmReglement: false,
        items: [
            {
            id: 1,
            name: 'Préstations',
            children: [],
            },
            {
            id: 5,
            name: 'Fret',
            children: [],
            },
        ],
        conteneurList: [],
        dataTmp:{},
        correspondantList: [],
        agentList: [],
        dossierList: [],
        factureContentTmp:{data: {}, dossier: {}},
        currentDossierVar: {},
        nb_jours: 0,
        period1: "0",
        prix_period1:"0",
        calcul_en_fc: 'Poids',
        menu_enlevement: false,
        period2: "0",
        prix_period2:"0",
        franchise: "0",
        hors_periode: "0",
        prix_hors_periode:"0",
        newData: [],
        deletedData: [],
        updatedData: [],
        newMarchandise: [],
        deletedMarchandise: [],
        updatedMarchandise: [],
        newPrestation: [],
        updatedPrestation: [],
        deletedPrestation: [],
        dossierList: [],
        updatedFacture: {},
        marchandises: [],
        magasinRules: [
            v => !!v || 'Ce champs est obligatoire.',
            //v => (v && (isNaN(v) || !Date.parse(v) ) ) || 'Vous devez entrer des valeurs corrects.',
        ],
        currentAvis: {},
        searchPrest: '',
        infoRules: [
            v => !!v || 'Ce champs est obligatoire',
        ],
        valid: false
    }),
    watch: {
        prix_period1: function(){
            this.calculprest()
        },
        prix_period2: function(){
            this.calculprest()
        },
        prix_hors_periode: function(){
            this.calculprest()
        },
        period1: function(){
            if (this.calculReste() < 0){
                this.period1 = 0
                this.snackColor = "error"
                this.snackbar = true
                this.snackText = "La durée insérée dépasse la durée totale."
            }else{
                this.hors_periode = this.calculReste()
                this.calculprest()
            }
        },

        period2: function(){
            if (this.calculReste() < 0){
                this.period2 = 0
                this.snackColor = "error"
                this.snackbar = true
                this.snackText = "La durée insérée dépasse la durée totale."
            }else{
                this.hors_periode = this.calculReste()
                this.calculprest()
            }
        },

        franchise: function(){
            if (this.calculReste() < 0){
                this.franchise = 0
                this.snackColor = "error"
                this.snackbar = true
                this.snackText = "La durée insérée dépasse la durée totale."
            }else{
                this.hors_periode = this.calculReste()
                this.calculprest()
            }
        },
        'currentFactureTmp.client_id': function(){
            if(Number(this.currentFactureTmp.client_id) > 0){
                var name = this.listClient.filter(obj => {
                    return obj.id === this.currentFactureTmp.client_id
                })[0].fullname
                this.reglementTmp.client = name
            }
        },
        currentDossierId: function(){
            if(this.currentDossierId > 0 && this.currentDossier === null){
                this.axios
                    .get('/dossier/single/'+this.dossierId)
                    .then(response => (this.currentDossierVar = response.data[0]))

            }else if(this.dossierId === 0){
    
            }
        },
        prestations: {
            deep: true,
            handler: 'calculate'
        },
        'factureContent.timbre': function() {
            this.calculate()
        }
    },
    computed : {
        _headersPrestations () {
            return this.headersPrestations.filter(x=>x.visible)
        }
    },
    mounted(){
        this.axios
            .get('/client/listing')
            .then(response => (this.listClient = response.data))
        
        this.axios
            .get('/correspondant/listing')
            .then(response => (this.correspondantList = response.data))
        this.axios
            .get('/agent/listing')
            .then(response => (this.agentList = response.data))
        
        //this.factureContentTmp = this.factureContent
        this.axios
            .get('/facture/single/'+this.factureContent.id)
            .then(response => {
                console.log(response.data.prestations)
                this.prestations = response.data.prestations
                response.data.data.forEach((item, key) => {
                    if(item.name === 'correspondant_id'){
                        this.axios
                        .get('/correspondant/listing')
                        .then(res => 
                        {
                            response.data.correspondant = res.data.filter(obj => {
                                return obj.id === Number(item.value)
                            })[0]
                        })
                       
                        
                    }else if(item.name === 'agent_id'){
                        this.axios
                        .get('/agent/listing')
                        .then(res => 
                        {
                            response.data.agent = res.data.filter(obj => {
                                return obj.id === Number(item.value)
                            })[0]
                        })
                        
                    }else{
                        response.data[item.name] = item.value
                        this.data.push(item)
                    }
                })
                var avis = {}
                
                this.axios
                    .get('/avis/single/'+this.factureContent.avis_id)
                    .then(res => (
                        avis = res.data
                    ))

                var self = this
                setTimeout(function(){
                    self.factureContentTmp = avis
                    self.factureContentTmp.data = response.data
                    self.marchandises = response.data.marchandise
                    self.change_jrs()
                    self.franchise = response.data.franchise
                    self.period1 = response.data.period1
                    self.period2 = response.data.period2
                    self.prix_period1 = response.data.prix_period1
                    self.prix_period2 = response.data.prix_period2
                    self.prix_hors_periode = response.data.prix_hors_period
                    self.hors_periode = response.data.hors_periode
                    self.currentFactureTmp.calcul_en_fc = response.data.calcul_en_fc
                    self.currentFactureTmp.type_calcul_value = response.data.calcul_valeur
                    self.typeCalculChange()
                    
                },400)
            })
        this.axios
        .get('/conteneur/listing')
        .then(response => (this.conteneurList = response.data))

        this.axios
        .get('/prestation/listing')
        .then(response => {
                var prestList = response.data
                function compare(a, b) {
                    // Use toUpperCase() to ignore character casing
                    const A = a.type_prestation;
                    const B = b.type_prestation;

                    let comparison = 0;
                    if (A < B) {
                        comparison = 1;
                    } else if (A > B) {
                        comparison = -1;
                    }
                    return comparison;
                }
                prestList.sort(compare)
                prestList.forEach((item, index) => {
                    
                    //item.id = index+1
                    item.name = item.description
                    item.prestation = item
                    if(item.cour === null){
                        item.cour = 0
                    }
                    if(item.montantDevise === null){
                        item.montantDevise = 0
                    }
                    if(item.type_prestation === 'Préstation'){
                        this.items[0].children.push(item)
                    }else{
                        this.items[1].children.push(item)
                    }
                })
            }
        )
        
        if(this.dossierId !== 0){
            this.axios
                .get('/dossier/single/'+this.dossierId)
                .then(response => {
                    this.currentDossierVar = response.data[0]
                    if(this.currentDossierVar.to_date.length !== 10){
                        this.currentDossierVar.from_date  = this.$options.filters.formatDate(this.currentDossierVar.from_date)
                        this.currentDossierVar.to_date = this.$options.filters.formatDate(this.currentDossierVar.to_date)
                        //this.currentDossierVar.date_depotage = this.$options.filters.formatDate(this.currentDossierVar.date_depotage)
                    }
                })
            this.currentDossierId = this.dossierId
        }
        
    },
    methods: {
        calculprest(){
            let unit = 0
            unit = Number(this.currentFactureTmp.type_calcul_value)
            if(this.currentFactureTmp.calcul_en_fc === 'Poids'){
                unit = Math.ceil(unit/1000)*1000
            }
            this.prestations[0].montant =  
            Number(
                Number(
                    (Number(this.period1) * Number(this.prix_period1) * unit ) 
                    + (Number(this.period2) * Number(this.prix_period2) * unit) 
                    + (Number(this.hors_periode) * Number(this.prix_hors_periode) * unit)
                    )
                .toFixed(3) 
            )
        },
        typeCalculChange(){
            this.currentFactureTmp.calcul_en_fc = this.calcul_en_fc
            if(this.currentFactureTmp.calcul_en_fc === 'Poids'){
                let totalpoids = 0
                this.marchandises.forEach((item, key) => {
                    totalpoids = totalpoids + item.poids
                })
                this.currentFactureTmp.type_calcul_value = totalpoids
            }else{
                let totalvolume = 0
                this.marchandises.forEach((item, key) => {
                    totalvolume = totalvolume + Number(item.volume)
                })
                this.currentFactureTmp.type_calcul_value = totalvolume
            }
        },
        calculReste(){
            return Number(this.nb_jours) - (Number(this.franchise) + Number(this.period1) + Number(this.period2))
        },
        addMarchandise(){
            if(this.currentDossierVar === null || (this.currentDossierVar.classe !== 'Aérien' && this.currentDossierVar.classe !== 'Groupage')){
                console.log(this.conteneurList.filter(obj => {
                    return obj.titre === this.marchandiseTmp.cont_type
                })[0].id)
                this.marchandiseTmp.cont_type_id = this.conteneurList.filter(obj => {
                    return obj.titre === this.marchandiseTmp.cont_type
                })[0].id
            }
            this.newMarchandise.push(this.marchandiseTmp)
            this.marchandises.push(this.marchandiseTmp)
            this.marchandiseTmp = {}
                        
        },
        change_jrs(){
            /*var dateString = this.currentDossier.date_depotage
            var dateParts = dateString.split("/")
            //var date2 = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])*/
            var date1 = new Date(this.factureContentTmp.data.date_enlevement)
            console.log(date1)
            
            var date2 = new Date(this.currentDossierVar.date_depotage)
            console.log(date2)
            this.nb_jours = parseInt((date1 - date2) / (1000 * 3600 * 24))
            this.hors_periode = this.calculReste()
        },
        setData(){
            this.data.push(this.dataTmp)
            this.dataTmp = {}
            //this.newData.push(this.dataTmp)
            this.setDataDialog = false
        },
        deleteData(item){
            const index = this.data.indexOf(item)
            if(item.facture_id){
                this.deletedData.push(item)
            }
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.data.splice(index, 1)
        },
        selectPrest(code, key){
            this.axios
                .get('/prestation/listing')
                .then(response => {
                    var result = response.data.filter(obj => {
                    return obj.code_prestation === code
                    })[0]
                    if(this.prestations.filter(obj => obj.code_prestation === result.code_prestation).length > 0){
                        this.snackText = "Cette préstation est déjà insérée."
                        this.snackColor = "error"
                        this.snackbar = true
                    }else{
                        if(!key)
                            key = 0
                        result.key = key+1
                        this.prestations.push(result)
                        this.newPrestation.push(result)
                    }
                }
            )
        },
        closeFacture(){
            this.$emit('hideDialog', true)
        },
        setReglement(){
            if(this.reglementTmp.mode === '' || this.reglementTmp.client === '' || Number(this.reglementTmp.montant) === 0){
                this.snackText = "Veuillez Remplir tous les cases obligatoires dans le règlement."
                this.snackColor = "error"
                this.snackbar = true
                console.log('problem')
            }else{
                this.reglementTmp.montant = Number(this.reglementTmp.montant).toFixed(3)
                let montant = this.reglementTmp.montant
                this.reglements.forEach((item,index) => {
                    montant = Number(Number(montant) + Number(Number(item.montant).toFixed(3)))
                })
                if(montant > Number(this.total.toFixed(3))){
                    this.snackText = "Le montant total des règlements ne doit pas dépasser le montant total de la facture."
                    this.snackColor = "error"
                    this.snackbar = true
                }else{
                    this.reglementTmp.facture_id = this.factureContent.id
                    this.axios
                        .post('/facture/reglement/set', this.reglementTmp, {})
                        .then(response => {
                            this.reglementTmp.id = response.data
                            this.reglements.push(this.reglementTmp)
                            this.reglementTmp = {
                                montant: 0,
                                mode: '',
                                client: '',
                                num_piece: '',
                                banque: ''
                            }
                            this.snackColor = "success"
                            this.snackText = "Le règlement a été ajouté avec succès."
                            this.snackbar = true
                            this.$emit('reloadData')
                            this.$emit('hideDialog')
                        })
                }
            }
            
        },
        calculate(){
            this.totalnt = 0
            this.totalt = 0
            this.totaltva = 0
            this.total = 0
            this.prestations.forEach((item , index) => {
                item.cour = Number(item.cour)
                item.montant = Number(item.montant)
                item.montantDevise = Number(item.montantDevise)
                
                item.tva = Number(item.tva)
                if(item.cour > 0){
                    this.prestations[index].montant = item.cour * item.montantDevise
                } 
                if(item.tva === 0){
                    this.totalnt = item.montant + this.totalnt
                }else{
                    this.totaltva = item.montant * item.tva / 100  + this.totaltva
                    this.totalt = item.montant + this.totalt
                }
                item.montantTva = Number(item.montant.toFixed(3)) * item.tva / 100
            })
            this.total =  Number(this.total.toFixed(3)) + Number(this.totalnt.toFixed(3)) + Number(this.totalt.toFixed(3)) + Number(this.totaltva.toFixed(3)) + Number(Number(this.factureContent.timbre).toFixed(3))
            this.reglementTmp.montant = this.total.toFixed(3)
        },
        editFacture(){
            if(this.valid !== true){
                this.snackColor = "error"
                this.snackText = "Essayez de remplir tous les champs obligatoires."
                this.snackbar = true
            }else{
                this.updatedFacture.id = this.factureContentTmp.data.id
                this.updatedFacture.libelle = this.factureContentTmp.data.libelle
                this.updatedFacture.reglements = this.reglements
                this.updatedFacture.timbre = Number(this.factureContent.timbre)
                //this.updatedFacture.client_id = this.factureContentTmp.client_id
                if(this.factureContentTmp.dossier_id > 0 && this.factureContent.avis_id === 0){
                    if(isNaN(this.factureContentTmp.agent)){
                        this.factureContentTmp.agent = this.factureContentTmp.agent.id
                    }
                    if(isNaN(this.factureContentTmp.correspondant)){
                        this.factureContentTmp.correspondant = this.factureContentTmp.correspondant.id
                    }
                    /*this.updatedData.push({name: 'pc', value: this.factureContentTmp.pc, facture_id: this.factureContentTmp.id})
                    this.updatedData.push({name: 'correspondant_id', value: this.factureContentTmp.correspondant, facture_id: this.factureContentTmp.id})
                    this.updatedData.push({name: 'agent_id', value: this.factureContentTmp.agent, facture_id: this.factureContentTmp.id})
                    this.updatedData.push({name: 'terme', value: this.factureContentTmp.terme, facture_id: this.factureContentTmp.id})
                    this.updatedData.push({name: 'fournisseur', value: this.factureContentTmp.fournisseur, facture_id: this.factureContentTmp.id})
                    if(this.currentDossierVar.classe === 'Groupage'){
                        this.updatedData.push({name: 'bureau', value: this.factureContentTmp.bureau, facture_id: this.factureContentTmp.id})
                        this.updatedData.push({name: 'code_magasin', value: this.factureContentTmp.code_magasin, facture_id: this.factureContentTmp.id})
                        this.updatedData.push({name: 'valeur', value: this.factureContentTmp.valeur, facture_id: this.factureContentTmp.id})
                    }*/
                }else{
                    //this.updatedData.push({name: 'agent_id', value: this.factureContentTmp.agent.id, facture_id: this.factureContentTmp.id})
                    
                    this.data.forEach((item, index) => {
                        if(item.id){
                            this.updatedData.push(item)
                        }else{
                            this.newData.push(item)
                        }
                    })
                }
                this.updatedData = []
                this.updatedData.push({name: 'date_enlevement', value: this.factureContentTmp.data.date_enlevement, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'franchise', value: this.franchise, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'calcul_en_fc', value: this.calcul_en_fc, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'calcul_valeur', value: this.currentFactureTmp.type_calcul_value, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'period1', value: this.period1, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'period2', value: this.period2, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'hors_periode', value: this.hors_periode, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'nb_jours', value: this.nb_jours, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'prix_period1', value: this.prix_period1, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'prix_period2', value: this.prix_period2, facture_id: this.factureContent.id})
                this.updatedData.push({name: 'prix_hors_period', value: this.prix_hors_periode, facture_id: this.factureContent.id})

                console.log(this.updatedData)
                this.prestations.forEach((item, index) => {
                    if(item.facture_id && item.code_prestation === '00'){
                        let prestTmp = Object.assign({}, {...item})
                        delete prestTmp.montantTva
                        this.updatedPrestation.push(prestTmp)
                    } else
                    if(item.facture_id && item.code_prestation !== '00'){
                        this.updatedPrestation.push(item)
                    }
                })
                this.marchandises.forEach((item, index) => {
                    if(item.facture_id){
                        this.updatedMarchandise.push(item)
                    }
                })
                this.updatedFacture.newData = this.newData
                this.updatedFacture.updatedData = this.updatedData
                this.updatedFacture.deletedData = this.deletedData
                this.updatedFacture.newMarchandise = this.newMarchandise
                this.updatedFacture.updatedMarchandise = this.updatedMarchandise
                this.updatedFacture.deletedMarchandise = this.deletedMarchandise
                this.updatedFacture.newPrestation = this.newPrestation
                this.updatedFacture.updatedPrestation = this.updatedPrestation
                this.updatedFacture.deletedPrestation = this.deletedPrestation

                //console.log(this.updatedFacture)
                var self = this
                setTimeout(function(){
                    self.axios.put('/facture/update', self.updatedFacture, {
                    }).then((res) => {
                        if(res.data === 'error'){
                        self.snackColor = "error"
                        self.snackText = "Essayez de remplir tous les champs obligatoires."
                        self.snackbar = true
                        }else{
                        self.snackColor = "success"
                        self.snackText = "La facture a été modifié avec succès."
                        self.snackbar = true
                        self.$emit('reloadData')
                        //self.closeFacture()
                        }
                    }).catch(e => {
                        self.snackColor = "error"
                        self.snackbar = true
                        self.snackText = "Un erreur est survenu, essayez plus tard."
                        console.log(e)
                    })
                },300)
                
            }

            
        },
        deleteReglement(item){
            const index = this.reglements.indexOf(item)
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.reglements.splice(index, 1)
        },
        deleteMarchandises (item) {
            const index = this.marchandises.indexOf(item)
            if(item.facture_id){
                this.deletedMarchandise.push(item)
            }
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.marchandises.splice(index, 1)
        },
        deletePrestation (item) {
            const index = this.prestations.indexOf(item)
            if(item.facture_id){
                this.deletedPrestation.push(item)
            }
            confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.prestations.splice(index, 1)
            
        }
    }
}
</script>
<style scoped>
.total-prices span{
    font-size: 16px;
    display: block;
    line-height: 9px;
}
.total-line{
    line-height: 45px;
    font-size: 18px;
    padding-left: 15px;
}
.v-snack {
    z-index: 99999;
}
.timbre-total >>> .v-small-dialog__activator__content {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/facture/magasinage/edit.component.vue